import React from 'react'
import { Carousel } from 'react-responsive-carousel';

const MediaSlider = ({images, videos}) => {
    return (
        <div className="verifi-slider">
            <Carousel showIndicators={false} showThumbs={false}>
                {images?.map((img, index) => {
                    return (
                        <div key={index.toString()}>
                            <img alt="img" src={img} />
                        </div>
                    );
                })}
                {videos?.map((video, index) => {
                    return (
                        <div key={index.toString()}>
                            <iframe
                                src={video}
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                            ></iframe>
                        </div>
                    );
                })}
            </Carousel>
        </div>
    )
}

export default MediaSlider